<template>
  <form
    action=""
    @submit.prevent="onSubmit"
  >
    <div
      :class="$style['form-wrapper']"
      class="gray-background-inner"
    >
      <div>
        <ds-label class="dark-label">
          <span slot="content">
            Użytkownik
          </span>
        </ds-label>
        <ds-input
          v-model="username"
          :validate-rules="{required: true}"
          name="username"
          placeholder="Wpisz nazwę użytkownika"
        />

        <div :class="$style['inner']">
          <div>
            <ds-label class="dark-label">
              <span slot="content">
                Hasło(ilość znaków)
              </span>
            </ds-label>
            <div :class="$style['slider-wrapper']">
              <ds-slider
                v-model="passwordLength"
                :options="sliderOptions"
              />
            </div>
          </div>
          <div>
            <div :class="$style['checkbox-form-group']">
              <ds-label class="dark-label">
                <span slot="content">
                  Hasło(opcje dodatkowe)
                </span>
              </ds-label>
              <div class="checkbox-box">
                <ds-checkbox-switch
                  :checked="capitalize"
                  @onChecked="onCapitalizeChecked"
                >
                  <span slot="text">Duże litery</span>
                </ds-checkbox-switch>
                <ds-checkbox-switch
                  :checked="numerals"
                  @onChecked="onNumeralsChecked"
                >
                  <span slot="text">Cyfry</span>
                </ds-checkbox-switch>
                <ds-checkbox-switch
                  :checked="special"
                  @onChecked="onSpecialChecked"
                >
                  <span slot="text">Znaki specjalne</span>
                </ds-checkbox-switch>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div :class="$style['submit-wrapper']">
          <ds-button>GENERUJ HASŁO</ds-button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { range } from "lodash";

export default {
  name: "HtpasswdGeneratorForm",
  data() {
    return {
      username: "",
      passwordLength: 6,
      capitalize: false,
      numerals: false,
      special: false
    };
  },
  computed: {
    sliderOptions() {
      return {
        initialValue: 2,
        width: "100%",
        tooltip: false,
        disabled: false,
        piecewise: true,
        piecewiseLabel: true,
        data: range(6, 33),
        piecewiseStyle: {
          backgroundColor: "#ccc",
          visibility: "visible",
          width: "12px",
          height: "12px"
        },
        piecewiseActiveStyle: {
          backgroundColor: "#3498db"
        }
      };
    }
  },
  methods: {
    onCapitalizeChecked(value) {
      this.capitalize = value;
    },
    onNumeralsChecked(value) {
      this.numerals = value;
    },
    onSpecialChecked(value) {
      this.special = value;
    },
    onSubmit() {
      this.$validator.validateAll().then(async result => {
        if (result) {
          this.$emit("onSubmit", this.username, {
            length: this.passwordLength,
            capitalize: this.capitalize,
            numerals: this.numerals,
            special: this.special
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" module>
@import "~@theme/scss/_mixins.scss";
@import "~@theme/scss/_variables.scss";

.submit-wrapper {
  margin-top: 10px;
}
.form-wrapper {
  display: block !important;
  input {
    width: 65% !important;
    @include mobile() {
      width: 100% !important;
    }
  }
}
.slider-wrapper {
  background-color: #fff;
  padding: 16px 24px 12px 24px;
  border-radius: 5px;
  margin-bottom: 21px;
}
.submit-wrapper {
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/app/dashboard/forms/htpasswd-generator-form.vue